import { useState } from "react";
import { useNavigate } from "react-router-dom";
import IndexDrawer from "layouts/ecommerce/posnavbar/Navbar";
import { PosCustomButton } from "../../../../customComponents/PosCustomButton/PosCustomButton";
import CustomTableGrid from "../../../../customComponents/CustomTableGrid/CustomTableGrid";
import "../index.css";
import "./inventory-compute.css";
import { MOCK_INVENTORY_SUMMARY, MOCK_INITIAL_INGREDIENTS } from "../MOCK_DATA_KOS";

// ─── Component ────────────────────────────────────────────────────────────────

export default function InventoryCompute() {
  const navigate = useNavigate();
  const [ingredients, setIngredients] = useState(
    MOCK_INITIAL_INGREDIENTS?.map((item) => ({
      ...item,
      poQty: Math.max(0, item.required - item.inStock),
    }))
  );

  const updateQty = (id, delta) => {
    setIngredients((prev) =>
      prev?.map((item) =>
        item.id === id ? { ...item, poQty: Math.max(0, item.poQty + delta) } : item
      )
    );
  };

  const totalCost = ingredients?.reduce((sum, item) => sum + item.poQty * item.unitCost, 0);

  const columns = [
    { key: "name", label: "Item Name" },
    { key: "vendor", label: "Vendor", render: (row) => <span className="ic_kos_vendor">{row.vendor}</span> },
    { key: "required", label: "Required", render: (row) => <><strong>{row.required}</strong> <span className="ic_kos_unit">{row.unit}</span></> },
    { key: "inStock", label: "In Stock", render: (row) => <span className="ic_kos_instock"><strong>{row.inStock}</strong> <span className="ic_kos_unit">{row.unit}</span></span> },
    {
      key: "poQty", label: "PO Qty", render: (row) => (
        <div className="ic_kos_qty-control">
          <button className="ic_kos_qty-btn" onClick={() => updateQty(row.id, -1)}>-</button>
          <span className="ic_kos_qty-val">{row.poQty}</span>
          <button className="ic_kos_qty-btn" onClick={() => updateQty(row.id, 1)}>+</button>
          <span className="ic_kos_unit">{row.unit}</span>
        </div>
      ),
    },
    { key: "estCost", label: "Est. Cost", render: (row) => <span className="ic_kos_cost">${(row.poQty * row.unitCost).toFixed(2)}</span> },
  ];

  return (
    <IndexDrawer pageTitle="Kitchen OS">
      <div className="idx_kos_wrapper">
        <div className="ic_kos_page">
          {/* Header */}
          <div className="ic_kos_header">
            <div className="ic_kos_header-left">
              <button className="ic_kos_back-btn" onClick={() => navigate(-1)}>&#8592;</button>
              <div>
                <p className="ic_kos_title">Compute Inventory</p>
                <p className="ic_kos_subtitle">Review shortages for today&apos;s prep requests and generate Purchase Orders.</p>
              </div>
            </div>
            <PosCustomButton title="Send PO to All Vendors" variant="green-d" p="8px 18px" fontSize="13px" border />
          </div>

          {/* Summary Cards */}
          <div className="ic_kos_summary-row">
            <div className="ic_kos_summary-card">
              <p className="ic_kos_summary-label">Items to Order</p>
              <p className="ic_kos_summary-value">{MOCK_INVENTORY_SUMMARY?.itemsToOrder}</p>
            </div>
            <div className="ic_kos_summary-card">
              <p className="ic_kos_summary-label">Vendors Involved</p>
              <p className="ic_kos_summary-value">{MOCK_INVENTORY_SUMMARY.vendorsInvolved}</p>
            </div>
            <div className="ic_kos_summary-card">
              <p className="ic_kos_summary-label">Estimated Cost</p>
              <p className="ic_kos_summary-value">${totalCost?.toFixed(2)}</p>
            </div>
          </div>

          {/* Table */}
          <div className="ic_kos_table-panel">
            <p className="ic_kos_section-title">Required Ingredients</p>
            <p className="ic_kos_section-sub">Adjust order quantities before pushing to purchase orders.</p>
            <CustomTableGrid
              columns={columns}
              rows={ingredients}
              gridTemplateColumns="2fr 1.5fr 1fr 1fr 1.5fr 1fr"
            />
          </div>
        </div>
      </div>
    </IndexDrawer>
  );
}
